"use client";
import { useState, useEffect, useContext } from "react";
import {
  IconButton,
  Modal,
  Typography,
  Box,
  Paper,
  Grid,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Button,
  Chip,
  Card,
  CardContent,
  alpha,
  Zoom,
  Tooltip,
  useMediaQuery,
  useTheme,
  Alert,
  Divider,
} from "@mui/material";

// Icons
import { Close as CloseIcon } from "@mui/icons-material";
import SendIcon from "@mui/icons-material/Send";
import EditIcon from "@mui/icons-material/Edit";
import DescriptionIcon from "@mui/icons-material/Description";
import PersonIcon from "@mui/icons-material/Person";
import BusinessIcon from "@mui/icons-material/Business";
import AttachMoneyIcon from "@mui/icons-material/AttachMoney";
import DiscountIcon from "@mui/icons-material/Discount";
import PaymentIcon from "@mui/icons-material/Payment";
import InventoryIcon from "@mui/icons-material/Inventory";
import CalendarTodayIcon from "@mui/icons-material/CalendarToday";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import StoreIcon from "@mui/icons-material/Store";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import HomeIcon from "@mui/icons-material/Home";
import ReceiptIcon from "@mui/icons-material/Receipt";
import PhoneIcon from "@mui/icons-material/Phone";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";
import DeleteIcon from "@mui/icons-material/Delete";
import TrendingUpIcon from "@mui/icons-material/TrendingUp";

import { useTenantNavigation } from "../../hooks/useTenantNavigation";
import { ErpContext } from "../../context/ErpContext.js";
import SpinnerLading from "../misc/SpinnerComponent.js";

const ModalViewTablaVenta = ({
  openModal,
  handleCloseModal,
  selectedTransaccion,
}) => {
  const [selectedTransaccionEntidad, setSelectedTransaccionEntidad] =
    useState(null);
  const [transaccionItems, setTransaccionItems] = useState([]);
  const [calculatedTotal, setCalculatedTotal] = useState(0);
  const [totalMontoDescuento, setTotalMontoDescuento] = useState(0);
  const [totalMontoInteres, setTotalMontoInteres] = useState(0);
  const [porcentajeDescuento, setPorcentajeDescuento] = useState(0);
  const [montoSinImpuesto, setMontoSinImpuesto] = useState(0);
  const [itemsMap, setItemsMap] = useState({});
  const [transaccionModificable, setTransaccionModificable] = useState([]);
  const [loading, setLoading] = useState(true);
  const [mostrarIva, setMostrarIva] = useState(false);
  const [itemsImpuestos, setItemsImpuestos] = useState({});
  const [mostrarColumnaImpuestos, setMostrarColumnaImpuestos] = useState(false);
  const [auditoriaEliminacion, setAuditoriaEliminacion] = useState(null); // ✅ Estado para auditoría de eliminación

  const navigate = useTenantNavigation();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const isTablet = useMediaQuery(theme.breakpoints.between("sm", "md"));
  const isMobileOrTablet = isMobile || isTablet;

  const {
    getTransaccionItemID,
    getEntidadByID,
    getItemById,
    ivaHardcoded,
    isNavbarCollapsed,
    getTransaccionImpuestoItems,
    getTransaccionAuditoria, // ✅ Función para obtener auditoría
    user,
    tieneAccesoFuncionalidad, // 🔒 Permiso granular para editar venta (btnEditarVenta)
  } = useContext(ErpContext);

  const handleDevolucionCanje = async (transaccionCanjeVenta) => {
    // console.log(transaccionCanjeVenta);
    if (transaccionCanjeVenta.length === 0) {
      console.error("No hay presupuestos disponibles para editar");
      return;
    }
    // Establecer el presupuesto a editar
    setTransaccionModificable(transaccionCanjeVenta);

    // Navegar directamente a la nueva ruta
    navigate(`gestionDevolucionVenta/${transaccionCanjeVenta.id}`);
  };

  const handleEditarVenta = async (transaccion) => {
    // console.log("Editando venta:", transaccion);
    if (!transaccion) {
      console.error("No hay venta disponible para editar");
      return;
    }

    // Validar que la venta NO esté facturada
    if (transaccion.tipoFacturaDescripcion) {
      console.error("No se puede editar una venta facturada");
      return;
    }

    // Navegar a GestionGenerarVentaComponent con el ID
    navigate(`gestionGenerarVenta/${transaccion.id}`);
  };

  // 🔒 DEBUG: Log para verificar condiciones del botón Editar Venta
  useEffect(() => {
    if (selectedTransaccion && openModal) {
      const noEstaFacturada = !selectedTransaccion?.tipoFacturaDescripcion;
      const tienePermiso = tieneAccesoFuncionalidad(user, 'VENTAS2', 'btnEditarVenta');
      
      // console.log("🔍 Verificación botón Editar Venta:", {
      //   transaccionId: selectedTransaccion?.id,
      //   noEstaFacturada,
      //   tipoFacturaDescripcion: selectedTransaccion?.tipoFacturaDescripcion,
      //   tienePermiso,
      //   user: user?.nombreUsuario,
      //   idRol: user?.idRol,
      //   accesosFuncionalidad: user?.accesosFuncionalidad,
      //   mostrarBoton: noEstaFacturada && tienePermiso
      // });
    }
  }, [selectedTransaccion, openModal, user, tieneAccesoFuncionalidad]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        if (selectedTransaccion) {
          //Estam puestos estos if porque por alguna razon hay selectedTransaccion que son undefined, por lo tanto el render del hook con MUI explota.
          // Obtener la entidad cliente
          // console.log("selectedTransaccion", selectedTransaccion);
          const entidadCliente = await getEntidadByID(
            selectedTransaccion.idEntidadNumero
          );
          setSelectedTransaccionEntidad(entidadCliente);

          // ✅ Obtener auditoría de eliminación si la transacción está eliminada
          if (selectedTransaccion.eliminado) {
            try {
              const auditoriaData = await getTransaccionAuditoria(selectedTransaccion.id);
              if (auditoriaData && auditoriaData.data) {
                setAuditoriaEliminacion(auditoriaData.data);
              } else {
                setAuditoriaEliminacion(null);
              }
            } catch (error) {
              // console.error("Error al obtener auditoría:", error);
              setAuditoriaEliminacion(null);
            }
          } else {
            setAuditoriaEliminacion(null);
          }

          // La lógica de mostrarIva ahora se basa en si hay impuestos específicos de items
          // Se maneja con mostrarColumnaImpuestos que se setea después de obtener los impuestos

          // Obtener los ítems de la transacción
          // ✅ Pasar mostrarEliminados basado en si la transacción está eliminada
          const mostrarEliminados = selectedTransaccion.eliminado || false;
          const items = await getTransaccionItemID(selectedTransaccion.id, mostrarEliminados);
          // console.log("items de la transacción:", items);

          // Obtener impuestos de los items de la transacción
          try {
            const impuestosItems = await getTransaccionImpuestoItems(selectedTransaccion.id);
            // console.log("Impuestos de items obtenidos:", impuestosItems);
            
            if (impuestosItems && impuestosItems.length > 0) {
              // Crear mapa de impuestos por item
              const impuestosMap = {};
              impuestosItems.forEach(impuesto => {
                impuestosMap[impuesto.idItem] = {
                  idImpuesto: impuesto.idImpuesto,
                  porcentaje: impuesto.porcentaje,
                  descripcionImpuesto: impuesto.descripcionImpuesto
                };
              });
              setItemsImpuestos(impuestosMap);
              setMostrarColumnaImpuestos(true);
            } else {
              setMostrarColumnaImpuestos(false);
            }
          } catch (error) {
            // console.log("No se encontraron impuestos para esta transacción:", error);
            setMostrarColumnaImpuestos(false);
          }

          // Obtener los detalles de cada Item
          const itemsWithDetails = await Promise.all(
            items.map(async (item) => {
              const itemDetails = await getItemById(item.idItem); // Obtener detalles del Item
              return {
                ...item, // Mantener los datos de la transacción
                codigo: itemDetails.codigo, // Agregar el código del Item
                descripcion: itemDetails.descripcion, // Agregar la descripción del Item
              };
            })
          );

          // console.log("items con detalles:", itemsWithDetails);
          setTransaccionItems(itemsWithDetails);

          const montoInteresItems = itemsWithDetails.reduce((total, item) => {
            const precio = Number(item?.precio) || 0;
            const cantidad = Number(item?.cantidad) || 0;
            const descuento = Number(item?.porcentajeDescuento) || 0;
            const interes = Number(item?.porcentajeInteres) || 0;
            const subtotalConDescuento = precio * cantidad * (1 - descuento / 100);
            return total + subtotalConDescuento * (interes / 100);
          }, 0);
          setTotalMontoInteres(montoInteresItems);

          // Crear el mapa de ítems
          const itemsMap = itemsWithDetails.reduce((map, item) => {
            map[item.idItem] = {
              codigo: item.codigo,
              descripcion: item.descripcion,
            };
            return map;
          }, {});

          setItemsMap(itemsMap);

          // Calcular montos
          const {
            montoTotal,
            impuestos = [],
            montoDescuento = 0,
            porcentajeDescuento = 0,
          } = selectedTransaccion;

          const totalSinImpuestos = impuestos
            .filter(
              (impuesto) => !impuesto.eliminado && !impuesto.incluidoEnPrecio
            )
            .reduce((total, impuesto) => {
              const monto = impuesto.montoTotal || 0;
              // console.log(
              //   `Total acumulado: ${total}, Impuesto aplicado: ${monto}`
              // );
              return total - monto;
            }, montoTotal);

          // console.log(
          //   "Resultado final de totalSinImpuestos:",
          //   totalSinImpuestos
          // );

          // Aplicar descuentos
          // console.log(totalSinImpuestos + " + " + montoDescuento);
          const totalSinImpuestosYDescuento =
            totalSinImpuestos + montoDescuento;
          const totalFinal =
            totalSinImpuestosYDescuento * (1 - porcentajeDescuento / 100);

          // Actualizar estados
          setCalculatedTotal(totalFinal);
          setTotalMontoDescuento(montoDescuento);
          setPorcentajeDescuento(porcentajeDescuento);
          setMontoSinImpuesto(totalSinImpuestosYDescuento);
        } else {
          setTotalMontoInteres(0);
        }
      } catch (error) {
        console.error("Error al cargar los datos:", error);
      } finally {
        setLoading(false); // Ocultar el spinner independientemente del resultado
      }
    };

    fetchData();
  }, [selectedTransaccion]);

  // Renderiza el spinner mientras está cargando
  if (loading) {
    return <SpinnerLading />;
  }

  return (
    <Modal
      open={openModal}
      onClose={handleCloseModal}
      aria-labelledby="modal-transaccion-titulo"
      aria-describedby="modal-transaccion-descripcion"
    >
      <Box
        className="modal-background"
        sx={{
          position: "absolute",
          top: isMobileOrTablet ? 0 : "50%",
          left: isMobileOrTablet ? 0 : "50%",
          transform: isMobileOrTablet ? "none" : "translate(-50%, -50%)",
          width: "100%",
          height: isMobileOrTablet ? "100vh" : "auto",
          maxHeight: isMobileOrTablet ? "100vh" : "90vh",
          display: "flex",
          alignItems: isMobileOrTablet ? "stretch" : "center",
          justifyContent: "center",
        }}
      >
        <Zoom in={openModal} timeout={300}>
          <Paper 
            className="modal-container"
            sx={{
              width: isMobileOrTablet ? "100%" : "80%",
              maxWidth: isMobileOrTablet ? "100%" : 1200,
              height: isMobileOrTablet ? "100%" : "auto",
              maxHeight: isMobileOrTablet ? "100vh" : "90vh",
              borderRadius: isMobileOrTablet ? 0 : 2,
              display: "flex",
              flexDirection: "column",
              overflow: "hidden",
            }}
          >
            {/* Header */}
            <Box
              sx={{
                bgcolor: "#5b5b5f",
                color: "white",
                p: isMobileOrTablet ? 1.5 : 2,
                borderTopLeftRadius: isMobileOrTablet ? 0 : 8,
                borderTopRightRadius: isMobileOrTablet ? 0 : 8,
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                marginBottom: isMobileOrTablet ? 1 : 2,
                position: "sticky",
                top: 0,
                zIndex: 10,
                flexShrink: 0,
              }}
            >
              <Box sx={{ display: "flex", alignItems: "center", gap: 1, flex: 1, minWidth: 0 }}>
                <ReceiptIcon fontSize={isMobileOrTablet ? "small" : "medium"} />
                <Typography
                  variant={isMobileOrTablet ? "subtitle1" : "h6"}
                  component="h2"
                  className="modal-title"
                  sx={{ 
                    color: "white", 
                    borderBottom: "none", 
                    m: 0, 
                    p: 0,
                    fontSize: isMobileOrTablet ? "0.875rem" : "1.25rem",
                    fontWeight: 600,
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                  }}
                >
                  Transacción #{selectedTransaccion?.id}
                </Typography>
                {selectedTransaccion?.tipoFacturaDescripcion && !isMobileOrTablet && (
                  <Chip
                    label={selectedTransaccion.tipoFacturaDescripcion}
                    size="small"
                    color="secondary"
                    sx={{
                      bgcolor: "rgb(244, 177, 14)",
                      color: "black",
                      fontWeight: "bold",
                      ml: 1,
                      fontSize: "0.7rem",
                    }}
                  />
                )}
              </Box>
              <IconButton
                onClick={handleCloseModal}
                sx={{ color: "white", flexShrink: 0 }}
                className="close-button"
                aria-label="cerrar"
                size={isMobileOrTablet ? "small" : "medium"}
              >
                <CloseIcon fontSize={isMobileOrTablet ? "small" : "medium"} />
              </IconButton>
            </Box>

            {/* Content */}
            <Box 
              sx={{ 
                p: isMobileOrTablet ? 1.5 : 3,
                flex: 1,
                overflow: "auto",
              }}
            >
              {/* Alerta de Eliminación - Solo si la transacción está eliminada */}
              {selectedTransaccion?.eliminado && auditoriaEliminacion && (
                <Box sx={{ mb: isMobileOrTablet ? 1.5 : 3 }}>
                  <Alert
                    severity="error"
                    icon={<DeleteIcon />}
                    sx={{
                      borderRadius: 2,
                      backgroundColor: alpha('#dc3545', 0.1),
                      border: '1px solid',
                      borderColor: alpha('#dc3545', 0.3),
                      '& .MuiAlert-icon': {
                        color: '#dc3545',
                      },
                    }}
                  >
                    <Box sx={{ mb: 1 }}>
                      <Typography variant="body2" fontWeight={600} gutterBottom>
                        Transacción Eliminada
                      </Typography>
                      <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5, mb: 1 }}>
                        <PersonIcon sx={{ fontSize: 14, color: 'text.secondary' }} />
                        <Typography variant="caption" color="text.secondary">
                          Eliminada por: <strong>{auditoriaEliminacion.usuario?.usuario || 'N/A'}</strong>
                        </Typography>
                      </Box>
                    </Box>
                    {auditoriaEliminacion.comentario && (
                      <>
                        <Divider sx={{ my: 1 }} />
                        <Typography variant="body2" fontWeight={600} gutterBottom>
                          Motivo de eliminación:
                        </Typography>
                        <Typography variant="body2" color="text.primary" sx={{ 
                          fontStyle: 'italic',
                          pl: 1,
                          borderLeft: `3px solid ${alpha('#dc3545', 0.5)}`,
                        }}>
                          {auditoriaEliminacion.comentario}
                        </Typography>
                      </>
                    )}
                  </Alert>
                </Box>
              )}

              {/* Información principal */}
              <Grid container spacing={isMobileOrTablet ? 1.5 : 3} sx={{ mb: isMobileOrTablet ? 1.5 : 3 }}>
                {/* Datos ERP */}
                <Grid item xs={12} md={4}>
                  <Card
                    elevation={isMobileOrTablet ? 1 : 2}
                    className="contenedorDatosModal"
                    sx={{
                      height: "100%",
                      borderLeft: isMobileOrTablet ? "3px solid #5b5b5f" : "4px solid #5b5b5f",
                      borderRadius: isMobileOrTablet ? 1 : 2,
                      transition: "all 0.3s ease",
                      "&:hover": {
                        boxShadow: isMobileOrTablet ? "none" : "0 8px 16px rgba(0,0,0,0.1)",
                        transform: isMobileOrTablet ? "none" : "translateY(-2px)",
                      },
                    }}
                  >
                    <CardContent sx={{ p: isMobileOrTablet ? 1.5 : 2 }}>
                      <Typography
                        variant={isMobileOrTablet ? "subtitle2" : "subtitle1"}
                        className="section-title"
                        sx={{
                          mb: isMobileOrTablet ? 1 : 2,
                          fontWeight: "bold",
                          display: "flex",
                          alignItems: "center",
                          gap: 0.5,
                          fontSize: isMobileOrTablet ? "0.875rem" : "1rem",
                        }}
                      >
                        <BusinessIcon fontSize={isMobileOrTablet ? "small" : "medium"} sx={{ color: "#5b5b5f" }} />
                        Datos ERP
                      </Typography>

                      <Box
                        sx={{
                          display: "flex",
                          flexDirection: "column",
                          gap: isMobileOrTablet ? 0.75 : 1,
                        }}
                      >
                        <Box
                          sx={{ 
                            display: "flex", 
                            alignItems: isMobileOrTablet ? "flex-start" : "center", 
                            gap: 0.5,
                            flexDirection: isMobileOrTablet ? "column" : "row",
                          }}
                        >
                          <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
                            <CalendarTodayIcon fontSize={isMobileOrTablet ? "small" : "small"} color="action" />
                            <Typography
                              variant="body2"
                              className="transaction-detail-label"
                              sx={{ fontSize: isMobileOrTablet ? "0.75rem" : "0.875rem", fontWeight: 600 }}
                            >
                              Fecha:
                            </Typography>
                          </Box>
                          <Typography
                            variant="body2"
                            className="transaction-detail-value"
                            sx={{ 
                              fontSize: isMobileOrTablet ? "0.75rem" : "0.875rem",
                              ml: isMobileOrTablet ? 0 : 0.5,
                            }}
                          >
                            {selectedTransaccion?.createdAt}
                          </Typography>
                        </Box>

                        <Box
                          sx={{ 
                            display: "flex", 
                            alignItems: isMobileOrTablet ? "flex-start" : "center", 
                            gap: 0.5,
                            flexDirection: isMobileOrTablet ? "column" : "row",
                          }}
                        >
                          <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
                            <DescriptionIcon fontSize={isMobileOrTablet ? "small" : "small"} color="action" />
                            <Typography
                              variant="body2"
                              className="transaction-detail-label"
                              sx={{ fontSize: isMobileOrTablet ? "0.75rem" : "0.875rem", fontWeight: 600 }}
                            >
                              Tipo:
                            </Typography>
                          </Box>
                          <Typography
                            variant="body2"
                            className="transaction-detail-value"
                            sx={{
                              color:
                                selectedTransaccion.idTipoTransaccionID == 1
                                  ? "#4CAF50"
                                  : "#757575",
                              fontWeight: "bold",
                              fontSize: isMobileOrTablet ? "0.75rem" : "0.875rem",
                              ml: isMobileOrTablet ? 0 : 0.5,
                            }}
                          >
                            {selectedTransaccion?.idTipoTransaccion || "N/A"}
                          </Typography>
                        </Box>

                        <Box
                          sx={{ 
                            display: "flex", 
                            alignItems: isMobileOrTablet ? "flex-start" : "center", 
                            gap: 0.5,
                            flexDirection: isMobileOrTablet ? "column" : "row",
                          }}
                        >
                          <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
                            <StoreIcon fontSize={isMobileOrTablet ? "small" : "small"} color="action" />
                            <Typography
                              variant="body2"
                              className="transaction-detail-label"
                              sx={{ fontSize: isMobileOrTablet ? "0.75rem" : "0.875rem", fontWeight: 600 }}
                            >
                              Negocio:
                            </Typography>
                          </Box>
                          <Typography
                            variant="body2"
                            className="transaction-detail-value"
                            sx={{ fontSize: isMobileOrTablet ? "0.75rem" : "0.875rem", ml: isMobileOrTablet ? 0 : 0.5 }}
                          >
                            {selectedTransaccion?.negocio || "N/A"}
                          </Typography>
                        </Box>

                        <Box
                          sx={{ 
                            display: "flex", 
                            alignItems: isMobileOrTablet ? "flex-start" : "center", 
                            gap: 0.5,
                            flexDirection: isMobileOrTablet ? "column" : "row",
                          }}
                        >
                          <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
                            <AccountCircleIcon fontSize={isMobileOrTablet ? "small" : "small"} color="action" />
                            <Typography
                              variant="body2"
                              className="transaction-detail-label"
                              sx={{ fontSize: isMobileOrTablet ? "0.75rem" : "0.875rem", fontWeight: 600 }}
                            >
                              Usuario:
                            </Typography>
                          </Box>
                          <Typography
                            variant="body2"
                            className="transaction-detail-value"
                            sx={{ fontSize: isMobileOrTablet ? "0.75rem" : "0.875rem", ml: isMobileOrTablet ? 0 : 0.5 }}
                          >
                            {selectedTransaccion?.usuario || "N/A"}
                          </Typography>
                        </Box>

                        <Box
                          sx={{ 
                            display: "flex", 
                            alignItems: isMobileOrTablet ? "flex-start" : "center", 
                            gap: 0.5,
                            flexDirection: isMobileOrTablet ? "column" : "row",
                          }}
                        >
                          <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
                            <LocationOnIcon fontSize={isMobileOrTablet ? "small" : "small"} color="action" />
                            <Typography
                              variant="body2"
                              className="transaction-detail-label"
                              sx={{ fontSize: isMobileOrTablet ? "0.75rem" : "0.875rem", fontWeight: 600 }}
                            >
                              Ubicación:
                            </Typography>
                          </Box>
                          <Typography
                            variant="body2"
                            className="transaction-detail-value"
                            sx={{ fontSize: isMobileOrTablet ? "0.75rem" : "0.875rem", ml: isMobileOrTablet ? 0 : 0.5 }}
                          >
                            {selectedTransaccion?.ubicacion || "N/A"}
                          </Typography>
                        </Box>
                      </Box>
                    </CardContent>
                  </Card>
                </Grid>

                {/* Datos Cliente */}
                <Grid item xs={12} md={4}>
                  <Card
                    elevation={isMobileOrTablet ? 1 : 2}
                    className="contenedorDatosModal"
                    sx={{
                      height: "100%",
                      borderLeft: isMobileOrTablet ? "3px solid rgb(244, 177, 14)" : "4px solid rgb(244, 177, 14)",
                      borderRadius: isMobileOrTablet ? 1 : 2,
                      transition: "all 0.3s ease",
                      "&:hover": {
                        boxShadow: isMobileOrTablet ? "none" : "0 8px 16px rgba(0,0,0,0.1)",
                        transform: isMobileOrTablet ? "none" : "translateY(-2px)",
                      },
                    }}
                  >
                    <CardContent sx={{ p: isMobileOrTablet ? 1.5 : 2 }}>
                      <Typography
                        variant={isMobileOrTablet ? "subtitle2" : "subtitle1"}
                        className="section-title"
                        sx={{
                          mb: isMobileOrTablet ? 1 : 2,
                          fontWeight: "bold",
                          display: "flex",
                          alignItems: "center",
                          gap: 0.5,
                          fontSize: isMobileOrTablet ? "0.875rem" : "1rem",
                        }}
                      >
                        <PersonIcon fontSize={isMobileOrTablet ? "small" : "medium"} sx={{ color: "rgb(244, 177, 14)" }} />
                        Datos del Cliente
                      </Typography>

                      <Box
                        sx={{
                          display: "flex",
                          flexDirection: "column",
                          gap: isMobileOrTablet ? 0.75 : 1,
                        }}
                      >
                        <Box
                          sx={{ 
                            display: "flex", 
                            alignItems: isMobileOrTablet ? "flex-start" : "center", 
                            gap: 0.5,
                            flexDirection: isMobileOrTablet ? "column" : "row",
                          }}
                        >
                          <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
                            <PersonIcon fontSize={isMobileOrTablet ? "small" : "small"} color="action" />
                            <Typography
                              variant="body2"
                              className="transaction-detail-label"
                              sx={{ fontSize: isMobileOrTablet ? "0.75rem" : "0.875rem", fontWeight: 600 }}
                            >
                              Nombre:
                            </Typography>
                          </Box>
                          <Typography
                            variant="body2"
                            className="transaction-detail-value"
                            sx={{ 
                              fontWeight: "500",
                              fontSize: isMobileOrTablet ? "0.75rem" : "0.875rem",
                              ml: isMobileOrTablet ? 0 : 0.5,
                            }}
                          >
                            {selectedTransaccion?.descripcionEntidad}{" "}
                            {selectedTransaccion?.apellido || ""}
                          </Typography>
                        </Box>

                        <Box
                          sx={{ 
                            display: "flex", 
                            alignItems: isMobileOrTablet ? "flex-start" : "center", 
                            gap: 0.5,
                            flexDirection: isMobileOrTablet ? "column" : "row",
                          }}
                        >
                          <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
                            <DescriptionIcon fontSize={isMobileOrTablet ? "small" : "small"} color="action" />
                            <Typography
                              variant="body2"
                              className="transaction-detail-label"
                              sx={{ fontSize: isMobileOrTablet ? "0.75rem" : "0.875rem", fontWeight: 600 }}
                            >
                              DNI/CUIT:
                            </Typography>
                          </Box>
                          <Typography
                            variant="body2"
                            className="transaction-detail-value"
                            sx={{ fontSize: isMobileOrTablet ? "0.75rem" : "0.875rem", ml: isMobileOrTablet ? 0 : 0.5 }}
                          >
                            {selectedTransaccion?.dniCuitCuil || "N/A"}
                          </Typography>
                        </Box>

                        <Box
                          sx={{ 
                            display: "flex", 
                            alignItems: isMobileOrTablet ? "flex-start" : "center", 
                            gap: 0.5,
                            flexDirection: isMobileOrTablet ? "column" : "row",
                          }}
                        >
                          <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
                            <HomeIcon fontSize={isMobileOrTablet ? "small" : "small"} color="action" />
                            <Typography
                              variant="body2"
                              className="transaction-detail-label"
                              sx={{ fontSize: isMobileOrTablet ? "0.75rem" : "0.875rem", fontWeight: 600 }}
                            >
                              Dirección:
                            </Typography>
                          </Box>
                          <Typography
                            variant="body2"
                            className="transaction-detail-value"
                            sx={{ fontSize: isMobileOrTablet ? "0.75rem" : "0.875rem", ml: isMobileOrTablet ? 0 : 0.5 }}
                          >
                            {selectedTransaccion?.direccion || "N/A"}
                          </Typography>
                        </Box>

                        <Box
                          sx={{ 
                            display: "flex", 
                            alignItems: isMobileOrTablet ? "flex-start" : "center", 
                            gap: 0.5,
                            flexDirection: isMobileOrTablet ? "column" : "row",
                          }}
                        >
                          <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
                            <LocationOnIcon fontSize={isMobileOrTablet ? "small" : "small"} color="action" />
                            <Typography
                              variant="body2"
                              className="transaction-detail-label"
                              sx={{ fontSize: isMobileOrTablet ? "0.75rem" : "0.875rem", fontWeight: 600 }}
                            >
                              Localidad:
                            </Typography>
                          </Box>
                          <Typography
                            variant="body2"
                            className="transaction-detail-value"
                            sx={{ fontSize: isMobileOrTablet ? "0.75rem" : "0.875rem", ml: isMobileOrTablet ? 0 : 0.5 }}
                          >
                            {selectedTransaccion?.localidad || "N/A"}
                          </Typography>
                        </Box>

                        <Box
                          sx={{ 
                            display: "flex", 
                            alignItems: isMobileOrTablet ? "flex-start" : "center", 
                            gap: 0.5,
                            flexDirection: isMobileOrTablet ? "column" : "row",
                          }}
                        >
                          <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
                            <LocationOnIcon fontSize={isMobileOrTablet ? "small" : "small"} color="action" />
                            <Typography
                              variant="body2"
                              className="transaction-detail-label"
                              sx={{ fontSize: isMobileOrTablet ? "0.75rem" : "0.875rem", fontWeight: 600 }}
                            >
                              Provincia:
                            </Typography>
                          </Box>
                          <Typography
                            variant="body2"
                            className="transaction-detail-value"
                            sx={{ fontSize: isMobileOrTablet ? "0.75rem" : "0.875rem", ml: isMobileOrTablet ? 0 : 0.5 }}
                          >
                            {selectedTransaccion?.provincia || "N/A"}
                          </Typography>
                        </Box>

                        <Box
                          sx={{ 
                            display: "flex", 
                            alignItems: isMobileOrTablet ? "flex-start" : "center", 
                            gap: 0.5,
                            flexDirection: isMobileOrTablet ? "column" : "row",
                          }}
                        >
                          <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
                            <PhoneIcon fontSize={isMobileOrTablet ? "small" : "small"} color="action" />
                            <Typography
                              variant="body2"
                              className="transaction-detail-label"
                              sx={{ fontSize: isMobileOrTablet ? "0.75rem" : "0.875rem", fontWeight: 600 }}
                            >
                              Teléfono:
                            </Typography>
                          </Box>
                          <Typography
                            variant="body2"
                            className="transaction-detail-value"
                            sx={{ fontSize: isMobileOrTablet ? "0.75rem" : "0.875rem", ml: isMobileOrTablet ? 0 : 0.5 }}
                          >
                            {selectedTransaccionEntidad?.telefono || "N/A"}
                          </Typography>
                        </Box>
                      </Box>
                    </CardContent>
                  </Card>
                </Grid>

                {/* Datos Financieros */}
                <Grid item xs={12} md={4}>
                  <Card
                    elevation={isMobileOrTablet ? 1 : 2}
                    className="contenedorDatosModal"
                    sx={{
                      height: "100%",
                      borderLeft: isMobileOrTablet ? "3px solid #4CAF50" : "4px solid #4CAF50",
                      borderRadius: isMobileOrTablet ? 1 : 2,
                      transition: "all 0.3s ease",
                      "&:hover": {
                        boxShadow: isMobileOrTablet ? "none" : "0 8px 16px rgba(0,0,0,0.1)",
                        transform: isMobileOrTablet ? "none" : "translateY(-2px)",
                      },
                    }}
                  >
                    <CardContent sx={{ p: isMobileOrTablet ? 1.5 : 2 }}>
                      <Typography
                        variant={isMobileOrTablet ? "subtitle2" : "subtitle1"}
                        className="section-title"
                        sx={{
                          mb: isMobileOrTablet ? 1 : 2,
                          fontWeight: "bold",
                          display: "flex",
                          alignItems: "center",
                          gap: 0.5,
                          fontSize: isMobileOrTablet ? "0.875rem" : "1rem",
                        }}
                      >
                        <AttachMoneyIcon fontSize={isMobileOrTablet ? "small" : "medium"} sx={{ color: "#4CAF50" }} />
                        Datos Financieros
                      </Typography>

                      <Box
                        sx={{
                          display: "flex",
                          flexDirection: "column",
                          gap: isMobileOrTablet ? 0.75 : 1,
                        }}
                      >
                        {/* Subtotal */}
                        <Box
                          sx={{ 
                            display: "flex", 
                            alignItems: isMobileOrTablet ? "flex-start" : "center", 
                            gap: 0.5,
                            flexDirection: isMobileOrTablet ? "column" : "row",
                          }}
                        >
                          <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
                            <AttachMoneyIcon fontSize={isMobileOrTablet ? "small" : "small"} color="action" />
                            <Typography
                              variant="body2"
                              className="transaction-detail-label"
                              sx={{ fontSize: isMobileOrTablet ? "0.75rem" : "0.875rem", fontWeight: 600 }}
                            >
                              Subtotal:
                            </Typography>
                          </Box>
                          <Typography 
                            variant="body2" 
                            className="value"
                            sx={{ fontSize: isMobileOrTablet ? "0.75rem" : "0.875rem", ml: isMobileOrTablet ? 0 : 0.5 }}
                          >
                            {new Intl.NumberFormat("es-AR", {
                              style: "currency",
                              currency: "ARS",
                            }).format(montoSinImpuesto || 0)}
                          </Typography>
                        </Box>

                        {/* Descuentos */}
                        <Box
                          sx={{ 
                            display: "flex", 
                            alignItems: isMobileOrTablet ? "flex-start" : "center", 
                            gap: 0.5,
                            flexDirection: isMobileOrTablet ? "column" : "row",
                          }}
                        >
                          <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
                            <DiscountIcon fontSize={isMobileOrTablet ? "small" : "small"} color="action" />
                            <Typography
                              variant="body2"
                              className="transaction-detail-label"
                              sx={{ fontSize: isMobileOrTablet ? "0.75rem" : "0.875rem", fontWeight: 600 }}
                            >
                              Descuento:
                            </Typography>
                          </Box>
                          <Typography 
                            variant="body2" 
                            className="value"
                            sx={{ fontSize: isMobileOrTablet ? "0.75rem" : "0.875rem", ml: isMobileOrTablet ? 0 : 0.5 }}
                          >
                            {new Intl.NumberFormat("es-AR", {
                              style: "currency",
                              currency: "ARS",
                            }).format(totalMontoDescuento || 0)}
                            {porcentajeDescuento > 0 &&
                              ` (${porcentajeDescuento}%)`}
                          </Typography>
                        </Box>

                        {totalMontoInteres > 0 && (
                          <Box
                            sx={{
                              display: "flex",
                              alignItems: isMobileOrTablet ? "flex-start" : "center",
                              gap: 0.5,
                              flexDirection: isMobileOrTablet ? "column" : "row",
                            }}
                          >
                            <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
                              <TrendingUpIcon fontSize={isMobileOrTablet ? "small" : "small"} color="success" />
                              <Typography
                                variant="body2"
                                className="transaction-detail-label"
                                sx={{ fontSize: isMobileOrTablet ? "0.75rem" : "0.875rem", fontWeight: 600 }}
                              >
                                Interés:
                              </Typography>
                            </Box>
                            <Typography
                              variant="body2"
                              className="value"
                              sx={{ fontSize: isMobileOrTablet ? "0.75rem" : "0.875rem", ml: isMobileOrTablet ? 0 : 0.5 }}
                            >
                              {new Intl.NumberFormat("es-AR", {
                                style: "currency",
                                currency: "ARS",
                              }).format(totalMontoInteres || 0)}
                            </Typography>
                          </Box>
                        )}

                        {(() => {
                          const pagoCheque = selectedTransaccion.pagos.find(
                            (p) => p.idTipoMedio === 8
                          );
                          return pagoCheque ? (
                            <Box
                              sx={{
                                display: "flex",
                                alignItems: isMobileOrTablet ? "flex-start" : "center",
                                gap: 0.5,
                                flexDirection: isMobileOrTablet ? "column" : "row",
                              }}
                            >
                              <Typography
                                variant="body2"
                                className="transaction-detail-label"
                                sx={{ fontSize: isMobileOrTablet ? "0.75rem" : "0.875rem", fontWeight: 600 }}
                              >
                                Datos Cheque:
                              </Typography>
                              <Typography 
                                variant="body2" 
                                className="value"
                                sx={{ fontSize: isMobileOrTablet ? "0.75rem" : "0.875rem", ml: isMobileOrTablet ? 0 : 0.5 }}
                              >
                                {selectedTransaccion.descripcion}
                              </Typography>
                            </Box>
                          ) : null;
                        })()}

                        {/* Impuestos */}
                        {selectedTransaccion?.impuestos &&
                          selectedTransaccion.impuestos.length > 0 && (
                            <Box>
                              <Typography
                                variant="body2"
                                className="transaction-detail-label"
                                sx={{ 
                                  mb: 0.5,
                                  fontSize: isMobileOrTablet ? "0.75rem" : "0.875rem",
                                  fontWeight: 600,
                                }}
                              >
                                Impuestos:
                              </Typography>

                              {selectedTransaccion.impuestos.every(
                                (imp) => !imp.incluidoEnPrecio
                              ) ? (
                                selectedTransaccion.impuestos
                                  .filter((imp) => !imp.eliminado)
                                  .map((imp, idx) => (
                                    <Box
                                      key={idx}
                                      sx={{
                                        display: "flex",
                                        alignItems: isMobileOrTablet ? "flex-start" : "center",
                                        ml: isMobileOrTablet ? 1 : 3,
                                        gap: 0.5,
                                        flexDirection: isMobileOrTablet ? "column" : "row",
                                        mb: 0.5,
                                      }}
                                    >
                                      <Typography
                                        variant="body2"
                                        className="transaction-detail-label"
                                        sx={{ fontSize: isMobileOrTablet ? "0.7rem" : "0.875rem" }}
                                      >
                                        • {imp.descripcion} ({imp.porcentaje}%):
                                      </Typography>
                                      <Typography
                                        variant="body2"
                                        className="value"
                                        sx={{ fontSize: isMobileOrTablet ? "0.7rem" : "0.875rem", ml: isMobileOrTablet ? 0 : 0.5 }}
                                      >
                                        {new Intl.NumberFormat("es-AR", {
                                          style: "currency",
                                          currency: "ARS",
                                        }).format(imp.montoTotal || 0)}
                                      </Typography>
                                    </Box>
                                  ))
                              ) : (
                                <Typography
                                  variant="body2"
                                  sx={{ 
                                    ml: isMobileOrTablet ? 1 : 3, 
                                    fontStyle: "italic",
                                    fontSize: isMobileOrTablet ? "0.7rem" : "0.875rem",
                                  }}
                                >
                                  Los impuestos están incluidos en el total
                                </Typography>
                              )}
                            </Box>
                          )}

                        {/* Total */}
                        <Box
                          sx={{
                            display: "flex",
                            alignItems: isMobileOrTablet ? "flex-start" : "center",
                            gap: 0.5,
                            mt: 1,
                            p: isMobileOrTablet ? 0.75 : 1,
                            bgcolor: alpha("#4CAF50", 0.1),
                            borderRadius: 1,
                            flexDirection: isMobileOrTablet ? "column" : "row",
                          }}
                        >
                          <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
                            <AttachMoneyIcon
                              fontSize={isMobileOrTablet ? "small" : "small"}
                              sx={{ color: "#4CAF50" }}
                            />
                            <Typography
                              variant={isMobileOrTablet ? "body2" : "body1"}
                              className="transaction-detail-label"
                              fontWeight="bold"
                              sx={{ fontSize: isMobileOrTablet ? "0.75rem" : "1rem" }}
                            >
                              Total:
                            </Typography>
                          </Box>
                          <Typography 
                            variant={isMobileOrTablet ? "body2" : "body1"} 
                            className="value"
                            sx={{ 
                              fontSize: isMobileOrTablet ? "0.875rem" : "1rem",
                              fontWeight: "bold",
                              ml: isMobileOrTablet ? 0 : 0.5,
                            }}
                          >
                            {new Intl.NumberFormat("es-AR", {
                              style: "currency",
                              currency: "ARS",
                            }).format(selectedTransaccion?.montoTotal || 0)}
                          </Typography>
                        </Box>

                        {/* Medios de Pago */}
                        <Box sx={{ mt: 1 }}>
                          <Typography
                            variant="body2"
                            className="transaction-detail-label"
                            sx={{
                              mb: 0.5,
                              display: "flex",
                              alignItems: "center",
                              gap: 0.5,
                              fontSize: isMobileOrTablet ? "0.75rem" : "0.875rem",
                              fontWeight: 600,
                            }}
                          >
                            <PaymentIcon fontSize={isMobileOrTablet ? "small" : "small"} />
                            Medios de Pago:
                          </Typography>

                          {selectedTransaccion?.pagos &&
                          selectedTransaccion.pagos.length > 0 ? (
                            selectedTransaccion.pagos.map((pago, idx) => (
                              <Box
                                key={idx}
                                sx={{
                                  display: "flex",
                                  alignItems: isMobileOrTablet ? "flex-start" : "center",
                                  ml: isMobileOrTablet ? 1 : 3,
                                  gap: 0.5,
                                  flexDirection: isMobileOrTablet ? "column" : "row",
                                  mb: 0.5,
                                }}
                              >
                                <Typography
                                  variant="body2"
                                  className="transaction-detail-label"
                                  sx={{ fontSize: isMobileOrTablet ? "0.7rem" : "0.875rem" }}
                                >
                                  • {pago.descripcion}:
                                </Typography>
                                <Typography 
                                  variant="body2" 
                                  className="value"
                                  sx={{ fontSize: isMobileOrTablet ? "0.7rem" : "0.875rem", ml: isMobileOrTablet ? 0 : 0.5 }}
                                >
                                  {new Intl.NumberFormat("es-AR", {
                                    style: "currency",
                                    currency: "ARS",
                                  }).format(pago.monto || 0)}
                                </Typography>
                              </Box>
                            ))
                          ) : (
                            <Typography
                              variant="body2"
                              sx={{ 
                                ml: isMobileOrTablet ? 1 : 3, 
                                fontStyle: "italic",
                                fontSize: isMobileOrTablet ? "0.7rem" : "0.875rem",
                              }}
                            >
                              No hay información de pagos
                            </Typography>
                          )}
                        </Box>
                      </Box>
                    </CardContent>
                  </Card>
                </Grid>
              </Grid>

              {/* Tabla de Ítems */}
              <Box sx={{ mb: isMobileOrTablet ? 1.5 : 3 }}>
                <Typography
                  variant={isMobileOrTablet ? "subtitle1" : "h6"}
                  className="items-title"
                  sx={{
                    mb: isMobileOrTablet ? 1 : 2,
                    display: "flex",
                    alignItems: "center",
                    gap: 0.5,
                    color: "#5b5b5f",
                    fontSize: isMobileOrTablet ? "0.875rem" : "1.25rem",
                    fontWeight: 600,
                  }}
                >
                  <InventoryIcon fontSize={isMobileOrTablet ? "small" : "medium"} />
                  Ítems de la Transacción
                </Typography>

                <TableContainer
                  component={Paper}
                  elevation={isMobileOrTablet ? 1 : 3}
                  className="tableContainerItemList"
                  sx={{
                    borderRadius: isMobileOrTablet ? 1 : 2,
                    overflow: "auto",
                    maxHeight: isMobileOrTablet ? 250 : 300,
                    transition: "all 0.3s ease",
                    "&:hover": {
                      boxShadow: isMobileOrTablet ? "none" : "0 8px 16px rgba(0,0,0,0.1)",
                    },
                  }}
                >
                  <Table stickyHeader size={isMobileOrTablet ? "small" : "medium"}>
                    <TableHead>
                      <TableRow>
                        <TableCell 
                          className="table-header-cell"
                          sx={{ 
                            fontSize: isMobileOrTablet ? "0.7rem" : "0.875rem",
                            py: isMobileOrTablet ? 0.75 : 1,
                            px: isMobileOrTablet ? 0.5 : 1,
                          }}
                        >
                          Descripción
                        </TableCell>
                        <TableCell 
                          align="right" 
                          className="table-header-cell"
                          sx={{ 
                            fontSize: isMobileOrTablet ? "0.7rem" : "0.875rem",
                            py: isMobileOrTablet ? 0.75 : 1,
                            px: isMobileOrTablet ? 0.5 : 1,
                          }}
                        >
                          Cantidad
                        </TableCell>
                        <TableCell 
                          align="right" 
                          className="table-header-cell"
                          sx={{ 
                            fontSize: isMobileOrTablet ? "0.7rem" : "0.875rem",
                            py: isMobileOrTablet ? 0.75 : 1,
                            px: isMobileOrTablet ? 0.5 : 1,
                          }}
                        >
                          Precio
                        </TableCell>
                        <TableCell 
                          align="right" 
                          className="table-header-cell"
                          sx={{ 
                            fontSize: isMobileOrTablet ? "0.7rem" : "0.875rem",
                            py: isMobileOrTablet ? 0.75 : 1,
                            px: isMobileOrTablet ? 0.5 : 1,
                          }}
                        >
                          Desc.
                        </TableCell>
                        <TableCell
                          align="right"
                          className="table-header-cell"
                          sx={{
                            fontSize: isMobileOrTablet ? "0.7rem" : "0.875rem",
                            py: isMobileOrTablet ? 0.75 : 1,
                            px: isMobileOrTablet ? 0.5 : 1,
                          }}
                        >
                          Interés
                        </TableCell>
                        {mostrarColumnaImpuestos && (
                          <TableCell
                            align="right"
                            className="table-header-cell"
                            sx={{ 
                              fontSize: isMobileOrTablet ? "0.7rem" : "0.875rem",
                              py: isMobileOrTablet ? 0.75 : 1,
                              px: isMobileOrTablet ? 0.5 : 1,
                            }}
                          >
                            IVA
                          </TableCell>
                        )}
                        <TableCell 
                          align="right" 
                          className="table-header-cell"
                          sx={{ 
                            fontSize: isMobileOrTablet ? "0.7rem" : "0.875rem",
                            py: isMobileOrTablet ? 0.75 : 1,
                            px: isMobileOrTablet ? 0.5 : 1,
                          }}
                        >
                          Total
                        </TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {transaccionItems.length > 0 ? (
                        transaccionItems.map((item, index) => {
                          const precio = item.precio || 0;
                          const cantidad = item.cantidad || 0;
                          const descuento = item.porcentajeDescuento || 0;
                          const interes = item.porcentajeInteres || 0;
                          const totalItem = (
                            precio *
                            cantidad *
                            (1 - descuento / 100) *
                            (1 + interes / 100)
                          ).toFixed(2);

                          const foundItem = itemsMap[item.idItem];

                          return (
                            <TableRow
                              key={`${item.idTransaccion}-${item.idItem}-${index}`}
                              className={
                                index % 2 === 0
                                  ? "row-color-default"
                                  : "row-color-alt"
                              }
                              sx={{
                                transition: "background-color 0.2s ease",
                                "&:hover": {
                                  backgroundColor: alpha("#5b5b5f", 0.05),
                                },
                              }}
                            >
                              <TableCell 
                                className="table-cell"
                                sx={{ 
                                  py: isMobileOrTablet ? 0.75 : 1,
                                  px: isMobileOrTablet ? 0.5 : 1,
                                }}
                              >
                                <Typography 
                                  variant="body2" 
                                  fontWeight="medium"
                                  sx={{ fontSize: isMobileOrTablet ? "0.7rem" : "0.875rem" }}
                                >
                                  {foundItem
                                    ? isMobileOrTablet 
                                      ? `${foundItem.codigo} - ${foundItem.descripcion.substring(0, 30)}${foundItem.descripcion.length > 30 ? '...' : ''}`
                                      : `${foundItem.codigo} - ${foundItem.descripcion}`
                                    : "No encontrado"}
                                </Typography>
                              </TableCell>
                              <TableCell 
                                align="right" 
                                className="table-cell"
                                sx={{ 
                                  py: isMobileOrTablet ? 0.75 : 1,
                                  px: isMobileOrTablet ? 0.5 : 1,
                                }}
                              >
                                <Chip
                                  label={cantidad}
                                  size={isMobileOrTablet ? "small" : "small"}
                                  color="primary"
                                  variant="outlined"
                                  sx={{ 
                                    height: isMobileOrTablet ? 20 : 24,
                                    fontSize: isMobileOrTablet ? "0.65rem" : "0.75rem",
                                  }}
                                />
                              </TableCell>
                              <TableCell 
                                align="right" 
                                className="table-cell"
                                sx={{ 
                                  py: isMobileOrTablet ? 0.75 : 1,
                                  px: isMobileOrTablet ? 0.5 : 1,
                                  fontSize: isMobileOrTablet ? "0.7rem" : "0.875rem",
                                }}
                              >
                                {new Intl.NumberFormat("es-AR", {
                                  style: "currency",
                                  currency: "ARS",
                                }).format(precio)}
                              </TableCell>
                              <TableCell 
                                align="right" 
                                className="table-cell"
                                sx={{ 
                                  py: isMobileOrTablet ? 0.75 : 1,
                                  px: isMobileOrTablet ? 0.5 : 1,
                                }}
                              >
                                {descuento > 0 ? (
                                  <Chip
                                    label={`${descuento}%`}
                                    size={isMobileOrTablet ? "small" : "small"}
                                    color="secondary"
                                    variant="outlined"
                                    sx={{ 
                                      height: isMobileOrTablet ? 20 : 24,
                                      fontSize: isMobileOrTablet ? "0.65rem" : "0.75rem",
                                    }}
                                  />
                                ) : (
                                  <Typography sx={{ fontSize: isMobileOrTablet ? "0.7rem" : "0.875rem" }}>0%</Typography>
                                )}
                              </TableCell>
                              <TableCell
                                align="right"
                                className="table-cell"
                                sx={{
                                  py: isMobileOrTablet ? 0.75 : 1,
                                  px: isMobileOrTablet ? 0.5 : 1,
                                }}
                              >
                                {interes > 0 ? (
                                  <Chip
                                    label={`+${interes}%`}
                                    size={isMobileOrTablet ? "small" : "small"}
                                    color="success"
                                    variant="outlined"
                                    sx={{
                                      height: isMobileOrTablet ? 20 : 24,
                                      fontSize: isMobileOrTablet ? "0.65rem" : "0.75rem",
                                    }}
                                  />
                                ) : (
                                  <Typography sx={{ fontSize: isMobileOrTablet ? "0.7rem" : "0.875rem" }}>0%</Typography>
                                )}
                              </TableCell>
                              {mostrarColumnaImpuestos && (
                                <TableCell 
                                  align="right" 
                                  className="table-cell"
                                  sx={{ 
                                    py: isMobileOrTablet ? 0.75 : 1,
                                    px: isMobileOrTablet ? 0.5 : 1,
                                  }}
                                >
                                  {(() => {
                                    const impuestoItem = itemsImpuestos[item.idItem];
                                    if (impuestoItem) {
                                      return (
                                        <Chip 
                                          label={`${impuestoItem.porcentaje}%`} 
                                          size={isMobileOrTablet ? "small" : "small"} 
                                          color="success" 
                                          variant="outlined"
                                          title={impuestoItem.descripcionImpuesto || `IVA ${impuestoItem.porcentaje}%`}
                                          sx={{ 
                                            height: isMobileOrTablet ? 20 : 24,
                                            fontSize: isMobileOrTablet ? "0.65rem" : "0.75rem",
                                          }}
                                        />
                                      );
                                    }
                                    return <Typography sx={{ fontSize: isMobileOrTablet ? "0.7rem" : "0.875rem" }}>N/A</Typography>;
                                  })()}
                                </TableCell>
                              )}
                              <TableCell 
                                align="right" 
                                className="table-cell"
                                sx={{ 
                                  py: isMobileOrTablet ? 0.75 : 1,
                                  px: isMobileOrTablet ? 0.5 : 1,
                                  fontSize: isMobileOrTablet ? "0.7rem" : "0.875rem",
                                  fontWeight: "bold",
                                }}
                              >
                                <span className="value">
                                  {new Intl.NumberFormat("es-AR", {
                                    style: "currency",
                                    currency: "ARS",
                                  }).format(totalItem)}
                                </span>
                              </TableCell>
                            </TableRow>
                          );
                        })
                      ) : (
                        <TableRow>
                          <TableCell
                            colSpan={mostrarColumnaImpuestos ? 7 : 6}
                            align="center"
                            sx={{ py: 3 }}
                          >
                            <Typography variant="body1" color="text.secondary">
                              No hay ítems para mostrar
                            </Typography>
                          </TableCell>
                        </TableRow>
                      )}
                    </TableBody>
                  </Table>
                </TableContainer>
              </Box>

              {/* Acciones */}
              <Box
                sx={{
                  display: "flex",
                  justifyContent: isMobileOrTablet ? "center" : "flex-end",
                  gap: isMobileOrTablet ? 1 : 2,
                  borderTop: "1px solid #eee",
                  pt: isMobileOrTablet ? 1.5 : 2,
                  flexShrink: 0,
                  flexWrap: "wrap",
                }}
              >
                {/* Botón Editar Venta - Solo visible si NO está facturada Y tiene permiso granular */}
                {!selectedTransaccion?.tipoFacturaDescripcion && 
                 tieneAccesoFuncionalidad(user, 'VENTAS2', 'btnEditarVenta') && (
                  <Tooltip 
                    title="Editar venta no facturada" 
                    arrow
                  >
                    <Button
                      className="buttomOptionModal"
                      variant="contained"
                      endIcon={<EditIcon fontSize={isMobileOrTablet ? "small" : "medium"} />}
                      onClick={() => handleEditarVenta(selectedTransaccion)}
                      size={isMobileOrTablet ? "small" : "medium"}
                      fullWidth={isMobileOrTablet}
                      sx={{
                        bgcolor: "#1976d2",
                        fontSize: isMobileOrTablet ? "0.75rem" : "0.875rem",
                        py: isMobileOrTablet ? 0.75 : 1,
                        "&:hover": {
                          bgcolor: alpha("#1976d2", 0.9),
                        },
                      }}
                    >
                      Editar Venta
                    </Button>
                  </Tooltip>
                )}

                <Button
                  className="buttomOptionModal"
                  variant="contained"
                  endIcon={<SendIcon fontSize={isMobileOrTablet ? "small" : "medium"} />}
                  onClick={() => handleDevolucionCanje(selectedTransaccion)}
                  size={isMobileOrTablet ? "small" : "medium"}
                  fullWidth={isMobileOrTablet}
                  sx={{
                    bgcolor: "#5b5b5f",
                    fontSize: isMobileOrTablet ? "0.75rem" : "0.875rem",
                    py: isMobileOrTablet ? 0.75 : 1,
                    "&:hover": {
                      bgcolor: alpha("#5b5b5f", 0.9),
                    },
                  }}
                >
                  Devolución / Canje
                </Button>
              </Box>
            </Box>
          </Paper>
        </Zoom>
      </Box>
    </Modal>
  );
};

export default ModalViewTablaVenta;
